module.exports = __webpack_public_path__ + "img/sell-info.49e5531d.svg";